import { render } from "./AskForm.vue?vue&type=template&id=57d17ce8&scoped=true"
import script from "./AskForm.vue?vue&type=script&lang=js"
export * from "./AskForm.vue?vue&type=script&lang=js"

import "./AskForm.vue?vue&type=style&index=0&id=57d17ce8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-57d17ce8"

export default script